import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuUtilityService } from 'src/app/services/web/menu-utility.service';

@Component({
    selector: 'app-editable-card',
    templateUrl: './editable-card.component.html',
    styleUrls: ['./editable-card.component.scss'],
    standalone: false
})
export class EditableCardComponent implements OnInit {
  @Input() public header = '';
  @Input() public iconName = '';
  @Input() public iconColor = '#999';
  @Input() public icon = false;
  @Input() public headerLeftAlign = true;
  @Input() public headerBoldFont = true;
  @Input() public matchIconMargin = false;
  @Input() public showEditControls: boolean;
  @Input() public formValid: boolean;
  @Input() public viewOnly: boolean;
  @Input() public ignoreWriteAccess: boolean;
  @Input() public editTextOverride: string;
  @Input() public editIconOverride: string;
  @Input() public nestedPagePath: string = undefined;
  @Output() public editClick = new EventEmitter<any>();
  @Output() public discardClick = new EventEmitter<any>();
  @Output() public saveClick = new EventEmitter<any>();
  @Output() public cancelClick = new EventEmitter<MouseEvent>();
  @Output() public submitClick = new EventEmitter<MouseEvent>();

  public writeAccess: boolean;

  constructor(
    private menuService: MenuUtilityService
  ) {}

  public ngOnInit(): void {
    this.writeAccess = this.menuService.hasWriteAccess(this.nestedPagePath);

    if (!this.writeAccess) {
      this.showEditControls = false;
      this.viewOnly = true;
    }
  }

  public cancel(): void {
    this.cancelClick.emit();
  }

  public submit(): void {
    this.submitClick.emit();
  }

  public edit(): void {
    this.editClick.emit();
  }

  public discard(): void {
    this.discardClick.emit();
  }

  public save(): void {
    this.saveClick.emit();
  }
}
